import type { SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import { NATIVE_FIELD_CLASS } from '@/contabilidad/constants/ui';

interface NativeSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

export function NativeSelect({ error, className, ...props }: NativeSelectProps) {
  return (
    <select
      className={cn(NATIVE_FIELD_CLASS, error && 'border-rose-500 focus:border-rose-500', className)}
      {...props}
    />
  );
}
